var pt_br = {
    values: {
        Qualifier: 'Qualificador',
        Message: 'Mensagem',
        URI: 'URL:',
        ClientId: 'Client ID:',
        ClientSecret: 'Client Secret:',
        Default: 'Padrão',
        'Import from': 'Importar do Poço Web',
        'Could not request the configured resource': 'Não foi possível conectar com a configuração selecionada',
        'Need to register at least one instance in well import configuration':
            'É necessário configurar pelo menos uma instância de importação de poços',
        clickconfigure: 'Configurar instância',
        SelectAll: 'Selecionar todos',
        'What data to import from': 'Quais dados a serem importados de',
        PorePresure: 'Pressão de poros',
        FracturePressure: 'Pressão de Fratura',
        Location: 'Localização',
        'Only local connections are allowed': 'Apenas conexões locais são permitidas',
        'Error. Verify the url and credentials.': 'Erro. Verifique a url e as credenciais.',
        TrustCertificate: 'Ignorar certificado SSL',
        SearchWell: 'Buscar Poço...',
        'Need permissions to import data': 'Permissão necessária para importação',
        'Start date and time' : 'Hora e data de início',
        'seeds-import-data-message': 'Indique a data início da intervenção. ' + 
            'Esta data será usada como início da primeira operação e as datas de início e ' + 
            ' fim das operações subsequentes serão calculadas com base nas durações das mesmas.'
    }
}

module.exports = pt_br
